import { DateTime } from 'luxon';

import { isEndOfDay, isEndOfDayToday, isLaterToday, isTomorrow } from './date';

export const formatStart = (time: DateTime) => {
	if (!time.isValid) {
		return '';
	}

	if (time.hasSame(DateTime.now(), 'day') && time > DateTime.now()) {
		return `Today, ${time.toFormat('HH:mm')}`;
	}

	return 'Today';
};

export const formatEnd = (time: DateTime) => {
	if (!time.isValid) {
		return '';
	}

	if (isEndOfDayToday(time)) {
		return `End of Day`;
	}

	if (isLaterToday(time)) {
		return `Today, ${time.toFormat('HH:mm')}`;
	}

	if (isTomorrow(time) && !isEndOfDay(time)) {
		return `Tomorrow, ${time.toFormat('HH:mm')}`;
	}

	if (isTomorrow(time)) {
		return `Tomorrow`;
	}

	if (!isEndOfDay(time)) {
		return `${time.toFormat('ccc, dd LLL')}, ${time.toFormat('HH:mm')}`;
	}

	return `${time.toFormat('ccc, dd LLL')}`;
};

export default {
	formatStart,
	formatEnd,
};
